export default __webpack_public_path__ + "static/media/profilePhoto.4bc0b66d.png";